import React from "react";
import {
  Typography,
  Card,
  CardActions,
  CardContent,
  Button,
} from "@material-ui/core";
import ImageHomePage from "../assets/HomePage.png";
import ImageRodrigoLoredo from "../assets/Loredo.png"
import "../Style/HomePage.css";


const HomePage = () => {
  const handleClick = () => {
    window.location.href = `/calculator`;
  };

  return (
    <div className="HomePage">
      <div
        className="HomePage-Image"
        style={{ backgroundImage: `url(${ImageHomePage})` }}
      >
        <div className="HomePage-ContentTitle">
          <img
        className="HomePage-Image-Loredo"
        src={ImageRodrigoLoredo}
      ></img>
        <div className="HomePage-Title">
          <Typography className="HomePage-Title__Typography">
            DIMENSIONÁ TU ESFUERZO
          </Typography>
        </div>
        </div>
        
         <Typography className="HomePage-Subtitle__Typography">
            Calculadora Tributaria
          </Typography>
      </div>
      <div className="HomePage-Information">
        <Card className="HomePage-Information__Card">
          <CardContent>
            <Typography
              className="HomePage-Information__Typography"
              variant="h5"
              component="h2"
            >
              Calculá cuantos días del año 2021 vas a tener que trabajar para pagar sólo las contribuciones de la Ciudad de Córdoba e impuestos provinciales por tu casa, auto y/o actividades. Los datos ingresados son anónimos.
            </Typography>
          </CardContent>
          <CardActions className="HomePage-Information__CardActions">
            <Button
              onClick={handleClick}
              size="large"
              variant="contained"
            >
              Ingresa aqui
            </Button>
          </CardActions>
        </Card>
      </div>
    </div>
  );
};

export default HomePage;
